module.exports = __webpack_public_path__ + "img/jp.1f905d23.svg";